import React, {useContext, useState} from "react";
import {Button, makeStyles} from "@material-ui/core";
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../ToolBar/ToolBarUtils/ItemTypes";
import {ScreenDesignerContextNew} from "../../../../../../ContextComponents/ScreenDesignerContextNew";
import Panel from "./Grid/Panel";
import RenderComponents from "./ScreenComponents";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import {useSelector} from "react-redux";
import {ContextMenu} from "./ScreenComponents/RenderByType/ContextMenu";
import SelectTemplatesModal from "../ToolBar/ToolBarUtils/SelectTemplatesModal/SelectTemplatesModal";

export const primaryDropColor = '#266fa8';
const defaultShadowBox = `0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)`;
const useStyles = makeStyles({
    container: {
        overflow: 'auto',
        boxShadow: defaultShadowBox,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'baseline',
    }
});
const alignMiddleStyles = (isNoValues) => {
    if (isNoValues) {
        return {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }
    return {
        alignItems: 'baseline',
        justifyContent: 'initial'
    }
};
const initialContextState = {
    mouseX: null,
    mouseY: null,
};
const ScreenBar = () => {
    const classes = useStyles();
    const {
        screenValues, screenValues: {styles: sourceStyles}, onDropComponent, onMoveComponent, onDropMultipleComponents,
        selectedComponent,
        onSelectComponent,
        toggleOpenTemplates,
        onSelectTemplate,
        openSelectTemplate,
    } = useContext(ScreenDesignerContextNew);
    const {isOpenSidebar} = useSelector(state => state.screenDesigner);
    const [contextMenu, setContextMenu] = useState(initialContextState);
    const styles = sourceStyles ? sourceStyles[0] : {};
    const isSelected = selectedComponent && selectedComponent.path === '';
    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.screenBar,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            let newItem = {...item};
            const didDrop = monitor.didDrop();
            if (didDrop) {
                return
            }
            if (
                item.type === 'entity' ||
                item.type === 'context' ||
                item.type === 'interval' ||
                item.type === 'dataSource' ||
                item.type === 'shortcut' ||
                item.type === 'webSocket') {
                const otherComponentsIndex = screenValues.otherComponents ? screenValues.otherComponents.length : 0;
                onDropComponent(item, otherComponentsIndex, 'otherComponents');
                return
            }
            //checking for children, if not, insert item into new panel
            if (item.children && item.type === 'panel') {
                newItem = {
                    ...newItem, children: [{
                        type: 'panel',
                        styles: [{
                            width: "100%",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }],
                        children: []
                    }]
                }
            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    item.component = {
                        ...item.component, children: [{
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }],
                            children: item.component.children
                        }]
                    };
                }

                onMoveComponent(item.component, item.from, `children`, screenValues.children.length);
                return
            }
            if (item.dragType === 'multiple') {
                onDropMultipleComponents(item.component, screenValues.children.length, `children`);
                return
            }

            onDropComponent(newItem, screenValues.children.length, 'children')
        }
    });
    const isNoValues = (!screenValues.children || !screenValues.children.length) && !isOverCurrent;
    const noValuesStyle = alignMiddleStyles(isNoValues);
    return (
        <div
            id={'screen_designer_root'}
            style={{
                flex: 1,
                height: '100%',
                width: '100%',
                display: 'flex',
                overflow: 'auto',
                cursor: 'pointer',
                position: 'relative',
                alignItems: styles.alignItems,
                justifyContent: styles.justifyContent,
            }}
            onClick={() => onSelectComponent({...screenValues, type: 'container'}, '')}
            onContextMenu={e => {
                e.preventDefault()
                setContextMenu({
                    mouseX: e.clientX,
                    mouseY: e.clientY
                })
            }}
        >
            <Card
                ref={drop}
                className={`${classes.container}`}
                style={{
                    border: isSelected ? '1px dashed #266fa8' : '1px dashed transparent',
                    ...styles,
                    paddingLeft: isOpenSidebar ? 305 : 0,
                    ...noValuesStyle
                }}
            >
                {isNoValues && (
                    <>
                        <div style={{border: '3px rgba(0, 0, 0, 0.24) dashed', padding: 10}}>
                            <Typography color={"textSecondary"}>
                                Drop Your Components Here
                            </Typography>
                        </div>
                        <Typography color={"textSecondary"} style={{marginTop: 10}}>
                            Or
                        </Typography>
                        <div>
                            <Button variant={"outlined"} style={{marginTop: 10}}
                                    onClick={toggleOpenTemplates}
                            >
                                <Typography color={"textSecondary"}>
                                    Select template
                                </Typography>
                            </Button>
                        </div>
                    </>
                )}
                {screenValues.children.map((item, i) => {
                    return (
                        item.type === 'panel' ? (
                            <Panel
                                key={`children.${i}`}
                                panel={item}
                                path={`children.${i}`}
                                index={i}
                                parentPath={'children'}
                            />
                        ) : (
                            <RenderComponents
                                key={`children.${i}`}
                                item={item}
                                type={item.type}
                                parentPath={``}
                                index={i}
                                path={`children.${i}`}
                            />
                        )
                    )
                })}
                {isOverCurrent && (
                    <div style={{height: 30, width: '100%', border: '1px dashed gray'}}>

                    </div>
                )}
            </Card>
            <ContextMenu
                contextMenu={contextMenu}
                onClose={() => setContextMenu(initialContextState)}
                item={{...screenValues, type: 'container'}}
                editItem={onSelectComponent}
                onDropComponent={onDropComponent}
                path={""}
            />
            <SelectTemplatesModal
                onClose={toggleOpenTemplates}
                isOpen={openSelectTemplate}
                selectTemplate={onSelectTemplate}
            />
        </div>
    )
};

export default ScreenBar;